import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__grid">
          <div className="footer__brand">
            <img
              src="https://www.image2url.com/r2/default/images/1777128435495-e7e28c36-d73b-4780-afbf-672579576f88.png"
              alt="Marrakech Best Activities"
              className="footer__logo-img"
            />
            <p className="footer__tagline">
              {t('footer.description')}
            </p>
            <div className="footer__contact">
              <a href="tel:+212694401220" className="footer__contact-item">📞 +212 694 401 220</a>
              <a href="mailto:hello@marrakech-tours.com" className="footer__contact-item">✉ marrakechbestactivities4@gmail.com</a>
              <span className="footer__contact-item">📍 Askejour Res Raha Imm 11 Apt 37, Marrakech — Hamza Jillali</span>
            </div>
            <div className="footer__socials">
              <a href="https://www.instagram.com/marrakech_best_activities?igsh=dWNzaXN0d3ZqeGph&utm_source=qr" target="_blank" rel="noreferrer" className="footer__social" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a href="https://www.facebook.com/share/1BMR4oeNSp/?mibextid=wwXIfr" target="_blank" rel="noreferrer" className="footer__social" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="footer__social" aria-label="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
                </svg>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="footer__social" aria-label="Twitter / X">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="https://www.tripadvisor.com/Attraction_Review-g293734-d33258631-Reviews-Marrakech_Best_Activities-Marrakech_Marrakech_Safi.html" target="_blank" rel="noreferrer" className="footer__social" aria-label="TripAdvisor">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.006 4.295c-2.67 0-5.338.784-7.645 2.353H0l1.582 1.648c-.978 1.08-1.582 2.5-1.582 4.064a5.88 5.88 0 0 0 5.878 5.878 5.853 5.853 0 0 0 3.964-1.543L12 18.778l2.158-2.083a5.853 5.853 0 0 0 3.964 1.543 5.88 5.88 0 0 0 5.878-5.878c0-1.564-.604-2.984-1.582-4.064L24 6.648h-4.349c-2.307-1.569-4.976-2.353-7.645-2.353zm0 1.843c1.98 0 3.93.49 5.682 1.39a9.356 9.356 0 0 0-5.682 1.903 9.355 9.355 0 0 0-5.683-1.904 12.126 12.126 0 0 1 5.683-1.389zM5.878 9.516a4.034 4.034 0 1 1 0 8.067 4.034 4.034 0 0 1 0-8.067zm12.244 0a4.034 4.034 0 1 1 0 8.067 4.034 4.034 0 0 1 0-8.067zm-12.244 1.55a2.484 2.484 0 1 0 0 4.968 2.484 2.484 0 0 0 0-4.968zm12.244 0a2.484 2.484 0 1 0 0 4.968 2.484 2.484 0 0 0 0-4.968zm-12.244 1.048a1.436 1.436 0 1 1 0 2.872 1.436 1.436 0 0 1 0-2.872zm12.244 0a1.436 1.436 0 1 1 0 2.872 1.436 1.436 0 0 1 0-2.872z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer__col">
            <div className="footer__col-title">{t('footer.toursTitle')}</div>
            <ul className="footer__links">
              <li><Link to="/tours/atlas-mountains-day-trip">Atlas Mountains</Link></li>
              <li><Link to="/tours/agafay-desert-day-trip">Agafay Desert</Link></li>
              <li><Link to="/tours/ouzoud-waterfalls-trip">Ouzoud Waterfalls</Link></li>
              <li><Link to="/tours/ait-ben-haddou-kasbah">Aït Ben Haddou</Link></li>
              <li><Link to="/tours/essaouira-day-trip">Essaouira</Link></li>
              <li><Link to="/tours/marrakech-medina-guided-tour">Marrakech Medina</Link></li>
              <li><Link to="/tours">All Tours →</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <div className="footer__col-title">{t('footer.activitiesTitle')}</div>
            <ul className="footer__links">
              <li><Link to="/activities/hot-air-balloon-marrakech">Hot Air Balloon</Link></li>
              <li><Link to="/activities/camel-ride-palmeraie">Camel Ride</Link></li>
              <li><Link to="/activities/quad-agafay">Quad in Agafay</Link></li>
              <li><Link to="/activities/buggy-agafay">Buggy in Agafay</Link></li>
              <li><Link to="/activities/marrakech-cooking-class">Cooking Class</Link></li>
              <li><Link to="/activities/horseback-riding-lake-takerkoust">Horseback Riding</Link></li>
              <li><Link to="/activities">All Activities →</Link></li>
            </ul>
          </div>

          <div className="footer__col">
            <div className="footer__col-title">{t('footer.companyTitle')}</div>
            <ul className="footer__links">
              <li><Link to="/about">{t('footer.about')}</Link></li>
              <li><Link to="/testimonials">{t('footer.reviews')}</Link></li>
              <li><Link to="/faq">{t('footer.faq')}</Link></li>
              <li><Link to="/morocco-guide">{t('footer.guide')}</Link></li>
              <li><Link to="/contact">{t('footer.contact')}</Link></li>
              <li><Link to="/book">{t('nav.bookNow')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <span>{t('footer.copyright')}</span>
          <div className="footer__bottom-links">
            <a href="/privacy">{t('footer.privacy')}</a>
            <a href="/terms">{t('footer.terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
